module.exports = __webpack_public_path__ + "static/media/pic7.d3b3ae94.jpg";